const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHsbc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 296,
    height: 52.18,
    viewBox: "0 0 296 52.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.015 0 0-7.775 0-7.775C0-8.753-.84-9.61-1.94-9.61h-1.054v-.396h8.921v.396H4.873c-1.085 0-1.94.871-1.94 1.835V9.547c0 .948.84 1.833 1.94 1.833h1.054v.398h-8.921v-.398h1.054c1.115 0 1.94-.885 1.94-1.833V1.1h-10.57v8.447c0 .948.855 1.833 1.94 1.833h1.053v.398h-8.921v-.398h1.055c1.099 0 1.94-.885 1.94-1.833V-7.775c0-.964-.841-1.835-1.94-1.835h-1.055v-.396h8.921v.396H-8.63c-1.085 0-1.94.871-1.94 1.835 0 0 .014 7.775 0 7.775z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 38.283 28.078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.077-1.28-.717-3.223-1.818-4.215-1.058-.956-2.566-1.788-4.582-1.788-2.291 0-4.262 1.222-4.98 1.497-.435.167-1.005.149-1.345-.061-.397-.245-.641-.641-.733-1.375h-.336v7.547h.336c.306-2.322 1.39-3.686 2.063-4.461 1.1-1.268 3.177-1.986 5.178-1.665 1.59.255 3.33 1.98 3.139 4.117-.068.771-.237 1.893-1.84 2.94-1.006.658-2.435 1.591-3.789 2.49-1.709 1.133-3.26 2.36-3.696 2.857-.572.651-1.284 1.588-1.284 3.086 0 1.283.489 2.749 1.528 3.727s2.444 1.71 4.46 1.71 3.545-1.069 4.064-1.313 1.093-.187 1.42 0c.321.184.535.459.627 1.192h.336v-7.15h-.336c-.306 2.323-1.314 4.063-2.017 4.705s-2.077 1.528-4.124 1.131c-1.964-.381-2.92-1.269-3.101-2.841-.138-1.198.512-1.935.886-2.383.764-.916 5.611-3.663 7.806-5.561C-1.007 3.209-.121 2.047 0 0",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 87.513 38.07)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.509-.467 4.382-.826 6.384.609 2.402 1.719 2.908 5.92-.482 8.109-1.365.882-4.771.821-5.902.555Zm0 10.501c1.069-.274 4.217-.348 5.438.428 1.914 1.215 2.578 3.165 2.225 4.889-.212 1.036-.76 1.992-1.706 2.657-1.863 1.314-4.551 1.101-5.957.673Zm7.027-.61c3.883-1.333 4.99-4.074 4.269-6.898-.846-3.32-4.59-3.995-5.804-4.156-.548-.071-1.947-.065-3.33-.065-2.468-.003-5.59.005-8.097.005v.397h1.284c.816 0 1.748.688 1.748 1.726v17.392c0 1.039-.932 1.741-1.741 1.741h-1.283v.398h7.745c1.863 0 2.875-.179 3.529-.306 1.099-.213 4.308-1.161 5.071-4.154.591-2.318-.565-5.24-3.391-6.08",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 103.992 48.438)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .314-7.378-.443-.016c-.214 1.865-.917 3.178-1.803 4.034-.255.246-.739.744-1.437 1.184-1.163.733-2.893 1.381-4.948 1.015-3.086-.55-4.675-2.589-5.469-4.552-.978-2.413-1.597-6.54.062-10.022 1.345-2.826 3.931-4.003 5.926-4.307 1.7-.259 5.469-.179 8.341 3.696l.458-.305c-2.231-3.147-5.194-5.163-8.585-5.132-4.338.038-7.064 2.429-8.31 3.849-1.314 1.497-2.322 4.338-2.335 6.813-.01 2.2.475 4.648 1.265 6.08 1.36 2.459 4.201 4.903 7.943 5.27 2.803.274 4.645-.275 6.219-1.176.786-.451 1.228-.503 1.656-.321.427.184.772.55.772 1.268z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 177.587 1.632)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.883-10.882v21.765Z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 194.981 26.046)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.765L10.882 10.882Z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 220.239 51.296)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.883 10.883h-21.765Z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 245.492 26.045)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#eee",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-21.765l10.883 10.882z",
    style: {
      fill: "#eee",
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    transform: "matrix(2.32049 0 0 -2.32049 270.746 .792)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsbc);
export default __webpack_public_path__ + "static/media/hsbc.b4f1fd8b217bf227d9cbe0d368f6e550.svg";
export { ForwardRef as ReactComponent };